/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popEnergy.vue?vue&type=template&id=47b013a9&scoped=true"
import script from "./popEnergy.vue?vue&type=script&lang=js"
export * from "./popEnergy.vue?vue&type=script&lang=js"
import style0 from "./popEnergy.vue?vue&type=style&index=0&id=47b013a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b013a9",
  null
  
)

export default component.exports